import React, { useState } from 'react';
import { connect } from 'react-redux'
import { resetFilter, saveFilterData } from '../../../actions';
import './style.css';
import { connectorImgs } from '../connectors';
import { markerImgs } from '../markers/images';
import { arrayRemove } from '../../../utils/helpers';

import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DeleteIcon from '@material-ui/icons/Delete';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Slider from '@material-ui/core/Slider';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';


function FilterDrawer({ open, toggleFilterDrawer, filter, saveFilterData }) {
    
    const [plugs, setPlugs] = useState([]);
    const [groups, setGroups] = useState([]);

    let handlePowerChange = (event, newValue) => {
        let data = JSON.parse(JSON.stringify(filter));
        data['power']['from'] = newValue[0] * 1000;
        data['power']['to'] = newValue[1] * 1000;

        saveFilterData(data)
    }

    const handlePlugChange = name => event => {
        let data = JSON.parse(JSON.stringify(filter));
        if (event.target.checked) {
            setPlugs(plugs => [...plugs, name]);
            data.connectors.find(x => x.icon === name).active = true;
        } else {
            setPlugs(arrayRemove(plugs, name));
            data.connectors.find(x => x.icon === name).active = false;
        }
        saveFilterData(data);
    };

    const handleGroupChange = name => event => {
        let data = JSON.parse(JSON.stringify(filter));
        if (event.target.checked) {
            setGroups(groups => [...groups, name]);
            data.groups.find(x => x.name === name).active = true;
        } else {
            setGroups(arrayRemove(groups, name));
            data.groups.find(x => x.name === name).active = false;
        }
        saveFilterData(data);
    };

    const handleResetFilter = () => {
        let data = JSON.parse(JSON.stringify(filter));
        data['power']['from'] = 0;
        data['power']['to'] = 350000;
        data.connectors.map((plug) => { return plug.active = true; });
        data.groups.map((group) => { return group.active = true; });
        saveFilterData(data);
    }

    const marks = [
        {
            value: 0,
            label: '0kW',
        },
        {
            value: 350,
            label: '350kW',
        },
    ];

    return (
        <Drawer 
            anchor='right' 
            open={open} 
            onClose={toggleFilterDrawer('right', false)}
            PaperProps={{ style: { position: 'absolute' } }}
            BackdropProps={{ style: { position: 'absolute' } }}
            ModalProps={{
                container: document.getElementById('finder-container'),
                style: { position: 'absolute' }
            }}
            variant="temporary"
        >
            <div className={'filter'}>
                <AppBar position="sticky">
                    <Toolbar>
                        <Typography noWrap variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                            <b>Filter</b>
                        </Typography>
                        <div>
                        <IconButton color={'inherit'} onClick={handleResetFilter}>
                            <Tooltip title={'Filter zurücksetzen'} placement={'left'}>
                                <DeleteIcon />
                            </Tooltip>
                        </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>
                <div className={'power'}>
                    <List dense subheader={<ListSubheader disableSticky>Leistung ({filter.power.from / 1000}kW - {filter.power.to / 1000}kW)</ListSubheader>}>
                        <ListItem divider key={'power'}>
                            <ListItemText style={{ textAlign: 'center' }}>
                                <Slider
                                    defaultValue={[filter.power.from / 1000, filter.power.to / 1000]}
                                    marks={marks}
                                    value={[filter.power.from / 1000, filter.power.to / 1000]}
                                    onChange={handlePowerChange}
                                    step={10}
                                    min={0}
                                    max={350}
                                    style={{ width: '90%' }}
                                />
                            </ListItemText>
                        </ListItem>
                    </List>
                </div>
                <div className={'groups'}>
                    <List dense subheader={<ListSubheader disableSticky>Gruppen</ListSubheader>}>
                        {filter.groups.map((group) => {

                            let name;

                            if (group.name === 'est') {
                                name = 'Energie Steiermark';
                            }
                            else if (group.name === 'beoe') {
                                name = 'BEÖ';
                            }
                            else if (group.name === 'others') {
                                name = 'Andere';
                            }
                            else if (group.name === 'roaming') {
                                name = 'Roaming';
                            }
                            else if (group.name === 'egg') {
                                name = 'Energie Graz';
                            }
                            else if (group.name === 'egg-taxi') {
                                name = 'Taxi';
                            }
                            else if (group.name.indexOf('_offline') !== -1) {
                                return false;
                            }

                            return <ListItem divider key={group.id}>
                                <ListItemIcon>
                                    <img alt={'marker'} src={markerImgs[group.name]} style={{ width: '30px', height: '30px' }} />
                                </ListItemIcon>
                                <ListItemText primary={name} />
                                <ListItemSecondaryAction>
                                    <Checkbox
                                        edge="end"
                                        checked={group.active}
                                        color="primary"
                                        onChange={handleGroupChange(group.name)}
                                        value={group.name}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        })}
                    </List>
                </div>
                <div className={'plugs'}>
                    <List dense subheader={<ListSubheader disableSticky>Stecker</ListSubheader>}>
                        {filter.connectors.map((plug) => {
                            return <ListItem divider key={plug.icon}>
                                <ListItemIcon>
                                    <img alt={'connector'} src={connectorImgs[plug.icon]} style={{ width: '35px', height: '35px' }} />
                                </ListItemIcon>
                                <ListItemText>
                                    {plug.label}
                                </ListItemText>
                                <ListItemSecondaryAction>
                                    <Checkbox
                                        edge="end"
                                        checked={plug.active}
                                        color="primary"
                                        onChange={handlePlugChange(plug.icon)}
                                        value={plug.icon}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        })}
                    </List>
                </div>
            </div>
        </Drawer>
    );
}

const mapStateToProps = (state) => ({
    filter: state.filter,
})
  
const mapDispatchToProps = {
    resetFilter: resetFilter,
    saveFilterData: saveFilterData
};

FilterDrawer = connect(mapStateToProps, mapDispatchToProps)(FilterDrawer);

export default FilterDrawer;